// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"_4190d0e","message":"_715b7f1"};